<template>
  <div class="content">
    <div class="password-container">
      <div class="password-card">
        <!-- 标题区域 -->
        <div class="password-header">
          <h2>修改登录密码</h2>
          <p>请谨慎操作，修改密码后需要重新登录</p>
        </div>

        <!-- 表单 -->
        <form @submit.prevent="isOk">
          <!-- 原密码 -->
          <div class="form-group">
            <label for="old">原密码</label>
            <div class="input-group">
              <input type="password" id="old" v-model="password" placeholder="请输入当前登录密码" maxlength="16" />
              <a class="forgot-link" @click="$parent.openKefu">忘记密码？</a>
            </div>
          </div>

          <!-- 新密码 -->
          <div class="form-group">
            <label for="new">新密码</label>
            <div class="input-group">
              <input type="password" id="new" v-model="paypassword" placeholder="请输入新的密码" maxlength="16" />
            </div>
            <div class="password-strength" v-if="paypassword">
              <span class="strength-text">密码强度: {{ getPasswordStrength() }}</span>
              <div class="strength-bar">
                <div class="strength-fill" :class="getStrengthClass()"></div>
              </div>
            </div>
          </div>

          <!-- 确认密码 -->
          <div class="form-group">
            <label for="confirm">确认密码</label>
            <div class="input-group">
              <input type="password" id="confirm" v-model="paypassword1" placeholder="请再次输入新密码" maxlength="16" />
            </div>
          </div>

          <!-- 密码说明 -->
          <div class="password-rules">
            密码由8-16位组成，必须包含字母和数字，建议使用字母、数字和符号的组合
          </div>

          <!-- 提交按钮 -->
          <button type="submit" class="submit-button">确认修改</button>
        </form>

        <!-- 弹窗提示 -->
        <div class="pay-dialog" style="display: none">
          <div class="pay-password">
            <div class="pay-password__header">提示</div>
            <p class="pay-password__title">
              <span>请您先绑定手机号后，再修改登录密码</span>
            </p>
            <div>
              <a href="javascript:void(0);" class="pay-password__button">前往设置</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resetPasswordNew',
  data() {
    return {
      password: null,
      paypassword: null,
      paypassword1: null
    };
  },
  methods: {
    isOk() {
      const that = this;
      const info = {
        password: that.password,
        paypassword: that.paypassword
      };

      if (!that.password) return that.$parent.showTost(0, '请输入旧密码');
      if (!that.paypassword) return that.$parent.showTost(0, '请输入新密码');
      if (that.password.length < 6) return that.$parent.showTost(0, '请输入正确的旧密码长度');

      // 新密码规则：8-16位，至少包含字母和数字
      const newPass = that.paypassword;
      if (newPass.length < 8 || newPass.length > 16) {
        return that.$parent.showTost(0, '新密码长度需为8-16位');
      }
      if (!/[A-Za-z]/.test(newPass) || !/[0-9]/.test(newPass)) {
        return that.$parent.showTost(0, '新密码需包含字母和数字');
      }

      if (!that.paypassword1) return that.$parent.showTost(0, '请输入确认密码');
      if (that.paypassword1 !== newPass) return that.$parent.showTost(0, '两次密码不一致！');
      if (that.password === newPass) return that.$parent.showTost(0, '新旧密码不能一致！');

      that.$parent.showLoading();
      that.$apiFun.post('/api/editPassword', info).then(res => {
        that.$parent.hideLoading();
        if (res.code !== 200) return that.$parent.showTost(0, res.message);

        that.$parent.showTost(1, res.message);
        localStorage.clear();
        sessionStorage.clear();
        that.$store.commit('changUserInfo');
        that.$store.commit('changToken');
        setTimeout(() => that.$parent.goNav('/login'), 1000);
      });
    },

    getPasswordStrength() {
      if (!this.paypassword) return '';
      let strength = 0;
      if (this.paypassword.length >= 8) strength++;
      if (/[A-Z]/.test(this.paypassword)) strength++;
      if (/[0-9]/.test(this.paypassword)) strength++;
      if (/[^A-Za-z0-9]/.test(this.paypassword)) strength++;
      if (strength < 2) return '弱';
      if (strength < 4) return '中';
      return '强';
    },

    getStrengthClass() {
      if (!this.paypassword) return '';
      let strength = 0;
      if (this.paypassword.length >= 8) strength++;
      if (/[A-Z]/.test(this.paypassword)) strength++;
      if (/[0-9]/.test(this.paypassword)) strength++;
      if (/[^A-Za-z0-9]/.test(this.paypassword)) strength++;
      if (strength < 2) return 'weak';
      if (strength < 4) return 'medium';
      return 'strong';
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 30px 15px;
  display: flex;
  justify-content: center;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 卡片容器 */
.password-container {
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
}

.password-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  box-sizing: border-box;
  width: 100%;
}

/* 标题 */
.password-header {
  text-align: center;
  margin-bottom: 30px;
}

.password-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 6px;
}

.password-header p {
  font-size: 14px;
  color: #718096;
}

/* 表单 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #4a5568;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-group input {
  width: 100%;
  padding: 12px 15px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  box-sizing: border-box;
  transition: all 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(66,153,225,0.2);
  background: #fff;
}

.input-group .link,
.forgot-link {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #4299e1;
  cursor: pointer;
  text-decoration: none;
}

.input-group .link:hover,
.forgot-link:hover {
  text-decoration: underline;
}

/* 密码规则 */
.password-rules {
  font-size: 13px;
  color: #718096;
  margin: 15px 0;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 3px solid #4299e1;
  box-sizing: border-box;
}

/* 提交按钮 */
.submit-button {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.submit-button:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(66,153,225,0.3);
}

.submit-button:active {
  transform: translateY(0);
}

/* 密码强度条 */
.password-strength {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.strength-text {
  font-size: 13px;
  color: #718096;
  margin-right: 10px;
}

.strength-bar {
  flex: 1;
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
}

.strength-fill {
  height: 100%;
  width: 0%;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.strength-fill.weak {
  width: 33%;
  background: #e53e3e;
}

.strength-fill.medium {
  width: 66%;
  background: #dd6b20;
}

.strength-fill.strong {
  width: 100%;
  background: #38a169;
}

/* 弹窗 */
.pay-dialog .pay-password {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  max-width: 380px;
  margin: 0 auto;
  text-align: center;
}

.pay-password__header {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 15px;
}

.pay-password__title span {
  font-size: 14px;
  color: #718096;
}

.pay-password__button {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 25px;
  background: #4a90e2;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.pay-password__button:hover {
  background: #3b82f6;
}

/* 响应式 */
@media (max-width: 480px) {
  .password-card {
    padding: 20px;
  }

  .password-header h2 {
    font-size: 20px;
  }

  .input-group .link {
    font-size: 11px;
  }

  .submit-button {
    padding: 12px 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/resetPasswordNew.vue